module.exports = __webpack_public_path__ + "img/cannery-5.d03d4ed2.jpeg";